import React from "react";
import { useCurrency } from "../contexts/CurrencyContext";

// ₹ | $ pill toggle. Sits in the navbar next to the language toggle.
// Hidden inside the Android app (₹ only there) and when PayPal isn't configured.
export default function CurrencyToggle({ compact = false }) {
  const { currency, setCurrency, usdEnabled, locked } = useCurrency();
  // Outside India there is only one rail (USD/PayPal) — nothing to toggle.
  if (!usdEnabled || locked) return null;
  const isUsd = currency === "USD";

  const btn = (active) => ({
    background: active ? "linear-gradient(135deg, #FFD166, #FFAA33)" : "transparent",
    color: active ? "#120021" : "rgba(255,255,255,0.65)",
    border: "none",
    borderRadius: "999px",
    padding: compact ? "4px 10px" : "5px 12px",
    fontSize: "0.78rem",
    fontWeight: 700,
    letterSpacing: "0.5px",
    cursor: "pointer",
    transition: "background-color 0.2s ease, color 0.2s ease",
  });

  return (
    <div
      data-testid="currency-toggle"
      role="group"
      aria-label="Currency"
      style={{
        display: "inline-flex",
        alignItems: "center",
        background: "rgba(255,255,255,0.05)",
        border: "1px solid rgba(255,209,102,0.18)",
        borderRadius: "999px",
        padding: "3px",
        marginRight: compact ? 0 : "8px",
      }}
    >
      <button data-testid="currency-toggle-inr" onClick={() => setCurrency("INR")} aria-pressed={!isUsd} style={btn(!isUsd)}>
        ₹ INR
      </button>
      <button data-testid="currency-toggle-usd" onClick={() => setCurrency("USD")} aria-pressed={isUsd} style={btn(isUsd)}>
        $ USD
      </button>
    </div>
  );
}
